/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;



//////////////////
// WEBPACK FOOTER
// ../webpack/buildin/amd-options.js
// module id = 2042
// module chunks = 25